import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment-timezone';
import { ManualAdjustmentSummary } from '../app-manual-adjustment-modal.component';
import { MoneyDTO } from '../../../../../../../../system/system-dtos';
import { MoneyService } from '../../../../../../../data-type-widgets/data-type/shared/money/money.service';
import { SignInService } from '../../../../../../../../common/services/sign-in/sign-in.service';
import { LottoUser } from '../../../../../../sign-in/user.model';

@Component({
  selector: 'app-manual-adjustment-confirmation',
  templateUrl: './manual-adjustment-confirmation.component.html',
  styleUrls: ['./manual-adjustment-confirmation.component.scss'],
  standalone: false,
})
export class ManualAdjustmentConfirmationComponent implements OnInit {
  @Input() summary: ManualAdjustmentSummary;

  currentUser: LottoUser;

  timestamp = moment.utc();

  constructor(
    private moneyService: MoneyService,
    private signInService: SignInService
  ) {
    this.currentUser = this.signInService.getCurrentUser();
  }

  ngOnInit(): void {}

  format(money: MoneyDTO): string {
    return this.moneyService.formatMoney(money, 'fullValue');
  }

  absNumber(value: number): number {
    return Math.abs(value);
  }

  absMoney(value: MoneyDTO): MoneyDTO {
    return this.moneyService.create(Math.abs(value.value), value.currency);
  }
}
